import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

export default function TaxTable(props) {
  const rows = props.rows;

  const formatNumber = (value) => {
    return typeof value === "number" ? value.toFixed(2) : "-";
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        border: "1px solid black",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Table sx={{ 
          minWidth: 650,
          "& .MuiTableCell-root": {
          textAlign: "center",
          }
        }} size="small">
        <TableHead>
          <TableRow>
            <TableCell>Line</TableCell>
            <TableCell>Tax Code</TableCell>
            <TableCell>Tax Value</TableCell>
            <TableCell>Total Tax Type Amount</TableCell>
            <TableCell>Total Exclude Tax</TableCell>
          </TableRow>
        </TableHead>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell colSpan={12}>
              <Typography textAlign="center" color="lightgray">
                No Data Available
              </Typography>
            </TableCell>
          </TableRow>
        ) : (
          <TableBody>
            {rows.map((row, i) => (
              <TableRow
                key={i}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{row.docTaxId || "-"}</TableCell>
                <TableCell width="200px">{row.taxCode || "-"}</TableCell>
                <TableCell>{row.taxValue || "-"}</TableCell>
                <TableCell>{formatNumber(row.totalTaxAmt) || "-"}</TableCell>
                <TableCell>{formatNumber(row.totalTaxableAmt) || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </TableContainer>
  );
}
